import React from 'react';

interface CustomModalProps {
  show: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

const CustomModal: React.FC<CustomModalProps> = ({ show, onClose, title, children }) => {
  if (!show) {
    return null;
  }

  const isMobile = window.innerWidth < 768; // Example breakpoint for mobile

  const modalStyle: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  };

  const modalContentStyle: React.CSSProperties = {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '5px',
    width: '500px',
    maxWidth: '90%',
    position: 'relative', // Needed for top adjustment
  };

  if (isMobile) {
    modalContentStyle.top = '-15vh'; // Move modal up by 15% of viewport height
    modalContentStyle.alignSelf = 'flex-start'; // Align to top
    modalContentStyle.marginTop = '10vh'; // Add some margin from the top
  }


  const modalHeaderStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #eee',
    paddingBottom: '10px',
    marginBottom: '20px',
  };

  const closeButtonStyle: React.CSSProperties = {
    border: 'none',
    backgroundColor: 'transparent',
    fontSize: '1.5rem',
    cursor: 'pointer',
  };

  return (
    <div style={modalStyle} onClick={onClose}>
      <div style={modalContentStyle} onClick={(e) => e.stopPropagation()}>
        <div style={modalHeaderStyle}>
          <h4>{title}</h4>
          <button style={closeButtonStyle} onClick={onClose}>&times;</button>
        </div>
        <div>{children}</div>
      </div>
    </div>
  );
};

export default CustomModal;